export const workplaceVocabulary = [
  {
    word: "Workstation",
    meaning: "작업대, 워크스테이션",
    audioId: 1,
  },
  {
    word: "Seat",
    meaning: "좌석, 자리",
    audioId: 2,
  },
  {
    word: "Partition",
    meaning: "칸막이, 파티션",
    audioId: 3,
  },
  {
    word: "Cubicle wall",
    meaning: "큐비클 벽, 사무실 칸막이 벽",
    audioId: 4,
  },
  {
    word: "Overhead light",
    meaning: "천장등, 실내 조명",
    audioId: 5,
  },
  {
    word: "Document tray",
    meaning: "서류함, 문서 트레이",
    audioId: 6,
  },
  {
    word: "Stationery",
    meaning: "문구류, 사무용품",
    audioId: 7,
    imageUrl: "/images/vocabulary/workplace/office9.png",
  },
  {
    word: "Laptop",
    meaning: "노트북컴퓨터",
    audioId: 8,
  },
  {
    word: "Spectacles",
    meaning: "안경",
    audioId: 9,
  },
  {
    word: "Pen holder",
    meaning: "펜꽂이",
    audioId: 10,
  },
  {
    word: "Sticky notes",
    meaning: "포스트잇, 접착 메모지",
    audioId: 11,
  },
  {
    word: "Diagram",
    meaning: "도표, 그림",
    audioId: 12,
  },
  {
    word: "Crumpled paper",
    meaning: "구겨진 종이",
    audioId: 13,
  },
  {
    word: "Cluttered",
    meaning: "어질러진, 잡동사니로 가득한",
    audioId: 14,
  },
  {
    word: "Display",
    meaning: "모니터, 디스플레이",
    audioId: 15,
  },
  {
    word: "Light fixture",
    meaning: "조명 기구, 전등 설비",
    audioId: 16,
  },
  {
    word: "Indoor plant",
    meaning: "실내 식물",
    audioId: 17,
  },
  {
    word: "Drawer cabinet",
    meaning: "서랍장, 캐비닛",
    audioId: 18,
  },
  {
    word: "Office screen",
    meaning: "사무실 칸막이 스크린",
    audioId: 19,
    imageUrl: "/images/vocabulary/workplace/office22.png",
  },
  {
    word: "Cupboard",
    meaning: "수납장, 찬장",
    audioId: 20,
    imageUrl: "/images/vocabulary/workplace/office23.png",
  },
  {
    word: "Bookcase",
    meaning: "책장, 책꽂이",
    audioId: 21,
  },
  {
    word: "Shades",
    meaning: "블라인드, 차양",
    audioId: 22,
  },
  {
    word: "Power cords",
    meaning: "전원 코드",
    audioId: 23,
    imageUrl: "/images/vocabulary/workplace/office26.png",
  },
  {
    word: "In a row",
    meaning: "일렬로",
    audioId: 24,
    imageUrl: "/images/vocabulary/workplace/office27.png",
  },
  {
    word: "Face",
    meaning: "향하다 (창문을 향하다, 문을 향해 있다 등)",
    audioId: 25,
    imageUrl: "/images/vocabulary/workplace/office28.png",
  },
  {
    word: "Arrange",
    meaning: "정리하다, 배치하다",
    audioId: 26,
  },
  {
    word: "Lower",
    meaning: "내리다",
    audioId: 27,
  },
  {
    word: "Flooring",
    meaning: "바닥재(재료), Floor는 바닥 그 자체",
    audioId: 28,
    imageUrl: "/images/vocabulary/workplace/office34.png",
  },
  {
    word: "Separated by",
    meaning: "~에 의해 분리된",
    audioId: 29,
  },
  {
    word: "Equipped with",
    meaning: "~가 갖춰진, ~가 장착된",
    audioId: 30,
  },
  {
    word: "Situated on",
    meaning: "~에 위치한",
    audioId: 31,
  },
  {
    word: "Stacked with",
    meaning: "~가 쌓여있는",
    audioId: 32,
  },
  {
    word: "Mounted on",
    meaning: "~에 설치된, 부착된",
    audioId: 33,
    imageUrl: "/images/vocabulary/workplace/office39.png",
  },
  {
    word: "Ceiling lights",
    meaning: "천장등(천장에 달린 조명 거의 다)",
    audioId: 34,
  },
  {
    word: "Pendant light",
    meaning: "펜던트 조명, 매달린 조명",
    audioId: 35,
    imageUrl: "/images/vocabulary/workplace/office42.png",
  },
  {
    word: "Side by side",
    meaning: "나란히",
    audioId: 36,
  },
  {
    word: "Against the wall",
    meaning: "벽에 붙어서",
    audioId: 37,
    imageUrl: "/images/vocabulary/workplace/office45.png",
  },
  {
    word: "Scatter across the desk",
    meaning: "책상 곳곳에 흩어져 있는",
    audioId: 38,
  },
  {
    word: "Place",
    meaning: "놓다, 두다",
    audioId: 39,
  },
  {
    word: "Suspend",
    meaning: "매달다",
    audioId: 40,
  },
  {
    word: "Step into",
    meaning: "~에 들어가다",
    audioId: 41,
  },
  {
    word: "Unoccupied",
    meaning: "비어 있는, 사용되지 않는",
    audioId: 42,
  },
  {
    word: "Conference table",
    meaning: "회의 테이블",
    audioId: 43,
  },
  {
    word: "Lean against",
    meaning: "~에 기대다",
    audioId: 44,
  },
  {
    word: "Labeled",
    meaning: "라벨이 붙은, 표시된",
    audioId: 45,
    imageUrl: "/images/vocabulary/workplace/office53.png",
  },
  {
    word: "Occupied",
    meaning: "사용 중인, 점유된",
    audioId: 46,
  },
  {
    word: "Engage in conversation",
    meaning: "대화에 참여하다",
    audioId: 47,
    imageUrl: "/images/vocabulary/workplace/office55.png",
  },
  {
    word: "Lean forward",
    meaning: "앞으로 몸을 기울이다",
    audioId: 48,
    imageUrl: "/images/vocabulary/workplace/office56.png",
  },
  {
    word: "Review",
    meaning: "검토하다, 리뷰하다 (서류 같은 것 볼 때)",
    audioId: 49,
    imageUrl: "/images/vocabulary/workplace/office57.png",
  },
  {
    word: "Hold a coffee cup",
    meaning: "커피 잔을 들다",
    audioId: 50,
  },
  {
    word: "Lean back",
    meaning: "뒤로 기대다",
    audioId: 51,
    imageUrl: "/images/vocabulary/workplace/office59.png",
  },
  {
    word: "Cross legs",
    meaning: "다리를 꼬다",
    audioId: 52,
  },
  {
    word: "Rest arm on armrest",
    meaning: "팔걸이에 팔을 올려놓다",
    audioId: 53,
    imageUrl: "/images/vocabulary/workplace/office61.png",
  },
  {
    word: "Cross arms",
    meaning: "팔짱을 끼다",
    audioId: 54,
    imageUrl: "/images/vocabulary/workplace/office62.png",
  },
  {
    word: "Sip",
    meaning: "조금씩 마시다",
    audioId: 55,
    imageUrl: "/images/vocabulary/workplace/office63.png",
  },
  {
    word: "Rest chin on hand",
    meaning: "턱을 손에 괴다",
    audioId: 56,
  },
  {
    word: "Wave",
    meaning: "손을 흔들다",
    audioId: 57,
  },
  {
    word: "Face each other",
    meaning: "서로 마주보다",
    audioId: 58,
    imageUrl: "/images/vocabulary/workplace/office67.png",
  },
  {
    word: "Give a presentation",
    meaning: "프레젠테이션을 하다",
    audioId: 59,
    imageUrl: "/images/vocabulary/workplace/office68.png",
  },
  {
    word: "Shake hands",
    meaning: "악수하다",
    audioId: 60,
  },
  {
    word: "Auditorium",
    meaning: "강당, 대강당",
    audioId: 61,
    imageUrl: "/images/vocabulary/workplace/office71.png",
  },
  {
    word: "Podium",
    meaning: "연단, 단상",
    audioId: 62,
    imageUrl: "/images/vocabulary/workplace/office72.png",
  },
  {
    word: "Neatly",
    meaning: "깔끔하게, 정돈되게",
    audioId: 63,
  },
  {
    word: "Tidily",
    meaning: "깔끔하게, 단정하게",
    audioId: 64,
  },
  {
    word: "Orderly",
    meaning: "질서 있게, 정연하게",
    audioId: 65,
  },
  {
    word: "Organized",
    meaning: "정리된, 조직화된",
    audioId: 66,
  },
  {
    word: "Overflow",
    meaning: "넘치는, 흘러넘치는",
    audioId: 67,
  },
  {
    word: "Against",
    meaning: "~에 기대어, ~에 맞서, ~에 반하여",
    audioId: 68,
  },
  {
    word: "Armrest",
    meaning: "팔걸이",
    audioId: 69,
  },
  {
    word: "Bulletin board",
    meaning: "게시판",
    audioId: 70,
    imageUrl: "/images/vocabulary/workplace/office80.png",
  },
  {
    word: "Audience",
    meaning: "청중, 관객",
    audioId: 71,
  },
  {
    word: "Filing cabinet",
    meaning: "서류 캐비닛",
    audioId: 72,
    imageUrl: "/images/vocabulary/workplace/office82.png",
  },
  {
    word: "Pinboard",
    meaning: "핀보드, 게시판",
    audioId: 73,
  },
  {
    word: "Ventilation system",
    meaning: "환기 시스템",
    audioId: 74,
    imageUrl: "/images/vocabulary/workplace/office84.png",
  },
  {
    word: "Distribute",
    meaning: "배포하다, 분배하다",
    audioId: 75,
    imageUrl: "/images/vocabulary/workplace/office85.png",
  },
  {
    word: "Landline phone",
    meaning: "유선 전화",
    audioId: 76,
    imageUrl: "/images/vocabulary/workplace/office86.png",
  },
  {
    word: "Clipboard",
    meaning: "클립보드",
    audioId: 77,
    imageUrl: "/images/vocabulary/workplace/office87.png",
  },
  {
    word: "Notebook",
    meaning: "수첩, 노트",
    audioId: 78,
  },
  {
    word: "File rack",
    meaning: "파일 꽂이, 서류 정리대",
    audioId: 79,
    imageUrl: "/images/vocabulary/workplace/office89.png",
  },
  {
    word: "Trash can",
    meaning: "쓰레기통",
    audioId: 80,
  },
  {
    word: "Potted plant",
    meaning: "화분에 심은 식물",
    audioId: 81,
  },
  {
    word: "Separate",
    meaning: "분리하다, 공간을 분리하다",
    audioId: 82,
  },
  {
    word: "Hand over a document",
    meaning: "서류 전달하다",
    audioId: 83,
  },
  {
    word: "Sort documents",
    meaning: "서류를 분류하다",
    audioId: 84,
  },
  {
    word: "Flip through a report",
    meaning: "보고서를 넘겨보다",
    audioId: 85,
    imageUrl: "/images/vocabulary/workplace/office95.png",
  },
  {
    word: "Carry a laptop",
    meaning: "노트북 들고 다니다",
    audioId: 86,
    imageUrl: "/images/vocabulary/workplace/office96.png",
  },
  {
    word: "Photocopy",
    meaning: "복사본 또는 복사하다(동사)",
    audioId: 87,
  },
  {
    word: "Vacant office",
    meaning: "빈 사무실",
    audioId: 88,
  },
  {
    word: "Power outlet",
    meaning: "전원 콘센트",
    audioId: 89,
    imageUrl: "/images/vocabulary/workplace/office100.png",
  },
];
